import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { invalidateAiListeningPromptData } from 'src/reactQuery/utils/aiListeningProfileCache'
import {
  AiListeningBrandProfileApiService,
  AiListeningErrorEnvelope,
} from 'src/services/aiListeningApi/brandProfile'

interface UseDeleteAiListeningProfileMutationParams {
  onError?: (error: AxiosError<AiListeningErrorEnvelope>) => void
  onSuccess?: () => void
}

// Cascades server-side to competitors, prompts and their history, so the
// prompt-level caches go too.
export const useDeleteAiListeningProfileMutation = ({
  onError,
  onSuccess,
}: UseDeleteAiListeningProfileMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (profileId: string) =>
      AiListeningBrandProfileApiService.deleteProfile(profileId),
    onError,
    onSuccess: () => {
      invalidateAiListeningPromptData(queryClient)
      onSuccess?.()
    },
  })
}
